import { useEffect, useState } from "react";
import { getHiperlyncURL } from "../../utils/ConstantsURL";

export const useHiperlyncLinks = (token, selectedDate, open, enabled) => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enabled || !open) return;

    const fetchLinks = async () => {
      setLoading(true);
      try {
        const [docRes, secRes] = await Promise.all([
          fetch(getHiperlyncURL("Documento",selectedDate), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
          fetch(getHiperlyncURL("Seccion",selectedDate), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        const [docData, secData] = await Promise.all([docRes.json(), secRes.json()]);

        const merged = [
          ...(docData || []).map((item) => ({ ...item, tipo: "Documento" })),
          ...(secData || []).map((item) => ({ ...item, tipo: "Sección" })),
        ];

        setLinks(merged);
      } catch (err) {
        console.error("Error al obtener hipervínculos:", err);
        setLinks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, [token, selectedDate, open, enabled]);

  return { links, loading };
};
